var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipsTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 77,
    viewBox: "0 0 75 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M37.084 33.9045L0 55.3183L37.084 76.7299L74.2354 55.3101L37.084 33.9045Z",
    fill: "url(#paint0_linear_471_1144)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1585 2.86255L14.6064 43.4408L50.574 64.2084V23.3112L15.1585 2.86255Z",
    fill: "url(#paint1_linear_471_1144)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 2.86252L19.8609 0L55.2765 20.4486L50.5737 23.3111L15.1582 2.86252Z",
    fill: "#41DCEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2769 61.346L50.5742 64.2085V23.3113L55.2769 20.4487V61.346Z",
    fill: "url(#paint2_linear_471_1144)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8066 36.1937V24.8065C21.8066 20.8756 26.0607 18.42 29.4639 20.3845L37.09 24.7882C40.747 26.8988 42.9982 30.8004 42.9982 35.0234V46.2226C42.9982 49.4396 39.5146 51.4497 36.7304 49.8413L26.1647 43.7396C23.4681 42.1822 21.8066 39.3048 21.8066 36.1919V36.1937Z",
    stroke: "white",
    strokeWidth: 1.46061,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8066 23.8206L43 36.0038",
    stroke: "white",
    strokeWidth: 1.46061,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6123 17.7004V24.0815",
    stroke: "white",
    strokeWidth: 1.46061,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6846 21.1328V27.512",
    stroke: "white",
    strokeWidth: 1.46061,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.202 30.4551C27.9615 31.127 28.4161 32.4909 28.2116 33.4859C28.0071 34.4809 27.2166 34.7438 26.4571 34.0683C25.6976 33.3928 25.2429 32.0289 25.4474 31.0376C25.6519 30.0462 26.4406 29.7833 27.202 30.4551Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2518 33.4256C33.0113 34.0975 33.4659 35.4613 33.2614 36.4564C33.0569 37.4514 32.2664 37.7143 31.5069 37.0388C30.7474 36.3632 30.2928 34.9994 30.4972 34.008C30.7017 33.0166 31.4904 32.7537 32.2518 33.4256Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0047 36.0987C37.7642 36.7706 38.2188 38.1344 38.0144 39.1295C37.8099 40.1245 37.0193 40.3874 36.2598 39.7119C35.5003 39.0363 35.0457 37.6725 35.2502 36.6811C35.4547 35.6897 36.2434 35.4268 37.0047 36.0987Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.202 36.9913C27.9615 37.6632 28.4161 39.027 28.2116 40.022C28.0071 41.0171 27.2166 41.28 26.4571 40.6044C25.6976 39.9289 25.2429 38.5651 25.4474 37.5737C25.6519 36.5823 26.4406 36.3194 27.202 36.9913Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2518 39.962C33.0113 40.6339 33.4659 41.9977 33.2614 42.9927C33.0569 43.9878 32.2664 44.2507 31.5069 43.5751C30.7474 42.8996 30.2928 41.5358 30.4972 40.5444C30.7017 39.553 31.4904 39.2901 32.2518 39.962Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0047 42.6348C37.7642 43.3067 38.2188 44.6705 38.0144 45.6656C37.8099 46.6606 37.0193 46.9235 36.2598 46.248C35.5003 45.5725 35.0457 44.2086 35.2502 43.2172C35.4547 42.2259 36.2434 41.963 37.0047 42.6348Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_471_1144",
    x1: -2.58854,
    y1: 69.7147,
    x2: 66.0854,
    y2: 44.7924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0633C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#063DD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0757E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0769F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0774FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0878FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_471_1144",
    x1: 9.5316,
    y1: 42.0055,
    x2: 49.5619,
    y2: 27.4761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_471_1144",
    x1: 41.9171,
    y1: 46.3239,
    x2: 60.959,
    y2: 39.4129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#132BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C34BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0739CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063BCE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsTask);
export default __webpack_public_path__ + "static/media/tips-task.b9577846ff5fbb72ca21922bed6dfdb2.svg";
export { ForwardRef as ReactComponent };